import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Progress } from '../../../components/ui/progress';
import API_BASE_URL from '../../../services/api';

const API = `${API_BASE_URL}/api`;

const ChunkedUploader = ({ onCompleteUrl, chunkSize = 5 * 1024 * 1024 }) => {
  const [file, setFile] = useState(null);
  const [uploadId, setUploadId] = useState(null);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);

  const initiate = async () => {
    if (!file) return;
    setBusy(true);
    setStatus('Préparation...');
    try {
      const form = new FormData();
      form.append('filename', file.name);
      form.append('size', file.size.toString());
      form.append('mime', file.type);
      form.append('total_chunks', Math.ceil(file.size / chunkSize).toString());
      const res = await fetch(`${API}/media/upload/initiate`, { method: 'POST', body: form, credentials: 'include' });
      const data = await res.json();
      if (data.upload_id) {
        setUploadId(data.upload_id);
        await sendChunks(data.upload_id);
      } else {
        throw new Error('initiate échoué');
      }
    } catch (e) {
      setStatus(`Erreur: ${e.message}`);
      setBusy(false);
    }
  };

  const sendChunks = async (id) => {
    const total = Math.ceil(file.size / chunkSize);
    for (let i = 0; i < total; i++) {
      setStatus(`Envoi du morceau ${i + 1}/${total}`);
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const blob = file.slice(start, end);
      const form = new FormData();
      form.append('upload_id', id);
      form.append('chunk_number', (i + 1).toString());
      form.append('chunk', blob, `${file.name}.part${i + 1}`);
      const res = await fetch(`${API}/media/upload/chunk`, { method: 'POST', body: form, credentials: 'include' });
      if (!res.ok) {
        setStatus('Erreur envoi chunk');
        setBusy(false);
        return;
      }
      setProgress(Math.round(((i + 1) / total) * 100));
    }
    await complete(id);
  };

  const complete = async (id) => {
    setStatus('Finalisation...');
    const form = new FormData();
    form.append('upload_id', id);
    const res = await fetch(`${API}/media/upload/complete`, { method: 'POST', body: form, credentials: 'include' });
    const data = await res.json();
    if (data.success) {
      setStatus('Terminé');
      if (onCompleteUrl) onCompleteUrl(data.url);
    } else {
      setStatus('Erreur finalisation');
    }
    setBusy(false);
  };

  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">Uploader un gros fichier (chunked)</div>
      <input type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
      <div className="flex gap-2">
        <Button type="button" disabled={!file || busy} onClick={initiate}>Envoyer en chunks</Button>
        {busy && <div className="text-xs text-muted-foreground">{status}</div>}
      </div>
      {busy && (
        <div className="mt-2">
          <Progress value={progress} />
          <div className="text-xs mt-1">{progress}%</div>
        </div>
      )}
    </div>
  );
};

export default ChunkedUploader;
